import { useRef, useState } from "react";
import { ScanLine, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const ScanRequeteButton = ({ onResult }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", f);
    try {
      const { data } = await api.post("/requetes/scan", fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 120000 });
      if (data.erreur) toast.warning(data.erreur); else toast.success("Requête lue : vérifiez chaque champ avant d'enregistrer");
      onResult(data, URL.createObjectURL(f));
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Numérisation impossible"); }
    finally { setBusy(false); }
  };
  return (
    <>
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" capture="environment" className="hidden" onChange={pick} data-testid="scan-requete-input" />
      <Button type="button" variant="outline" disabled={busy} onClick={() => input.current?.click()} data-testid="scan-requete-button"
              className="w-full border-dashed border-sky-300 text-sky-700 hover:bg-sky-50">
        {busy ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Lecture de la requête par l'IA…</> : <><ScanLine className="h-4 w-4 mr-2" /> Numériser une requête papier (photo ou scan)</>}
      </Button>
    </>
  );
};
